import { ReportRow } from '../ReportRow';

export interface PartnerPlatformSalesReport extends ReportRow {
  total: number;
}

const partnerPlatformSalesReportFromResponse = (
  responseData: any,
): PartnerPlatformSalesReport => ({
  createdAt: new Date(responseData.created_at),
  total: responseData.total,
});

export interface PartnerPlatformSalesReports {
  trendyol: PartnerPlatformSalesReport[];
  boyner: PartnerPlatformSalesReport[];
  hepsiburada: PartnerPlatformSalesReport[];
  n11: PartnerPlatformSalesReport[];
  pazarama: PartnerPlatformSalesReport[];
}

export const partnerPlatformSalesReportsFromResponse = (
  responseData: any,
): PartnerPlatformSalesReports => ({
  trendyol: (responseData.trendyol ?? []).map((report: any) =>
    partnerPlatformSalesReportFromResponse(report),
  ),
  boyner: (responseData.boyner ?? []).map((report: any) =>
    partnerPlatformSalesReportFromResponse(report),
  ),
  hepsiburada: (responseData.hepsiburada ?? []).map((report: any) =>
    partnerPlatformSalesReportFromResponse(report),
  ),
  n11: (responseData.n11 ?? []).map((report: any) =>
    partnerPlatformSalesReportFromResponse(report),
  ),
  pazarama: (responseData.pazarama ?? []).map((report: any) =>
    partnerPlatformSalesReportFromResponse(report),
  ),
});
